export const getFilenameFromPath = path => {
  return path.replace(/^.*[\\\/]/, '');
};
